{
  "blocks": [
    {
      "id": "proc-pap-smear",
      "kind": "procedure",
      "tags": ["testing", "her", "clinic-visit"],
      "title": "Pap smear",
      "subtitle": "Cervical screening test for abnormal cell changes",
      "body": {
        "procedureName": "Pap smear",
        "category": "diagnostic",
        "description": "A routine screening test that collects cells from the cervix to check for precancerous or abnormal changes. Many fertility clinics require an up-to-date Pap smear before starting treatment.",
        "howItWorks": "You lie on an exam table with your feet in stirrups. A speculum is gently inserted to open the vaginal canal and visualize the cervix. A small brush or spatula is used to gently scrape cells from the surface of the cervix and the opening of the cervical canal. The collected cells are placed in a liquid preservative and sent to a laboratory where they are examined under a microscope for abnormalities. HPV co-testing may be performed on the same sample.",
        "duration": "5–10 minutes",
        "anesthesia": "none",
        "painAndComfort": [
          "The speculum and swab may cause pressure or brief discomfort; light spotting afterward can occur."
        ],
        "whatToExpect": [
          "Brief discomfort or pressure when the speculum is inserted and cells are collected",
          "The cell collection takes only a few seconds",
          "You may experience very light spotting afterward, which is normal",
          "Results are typically available within 1–3 weeks",
          "Normal results are usually valid for 1–3 years depending on guidelines"
        ],
        "results": [
          {
            "label": "When you hear",
            "detail": "Pap results usually return in 1-3 weeks, depending on the lab and whether HPV testing is included."
          },
          {
            "label": "What you learn",
            "detail": "The report checks for abnormal cervical cells and may include HPV status if co-testing was ordered."
          },
          {
            "label": "Follow-up",
            "detail": "Normal results are typically valid for 1-3 years, while abnormal results may need repeat testing or colposcopy."
          }
        ],
        "prepInstructions": [
          "Schedule the test when you are not menstruating",
          "Avoid vaginal intercourse, douching, and vaginal medications for 48 hours before",
          "Let your clinic know if you are pregnant or think you might be"
        ],
        "risks": [
          "Very mild discomfort during the procedure",
          "Light spotting for a day or two is normal",
          "No serious risks"
        ],
        "forWhom": "her",
        "frBody": {
          "procedureName": "Frottis cervico-utérin",
          "description": "Examen de dépistage de routine qui recueille des cellules du col pour rechercher des modifications précancéreuses ou anormales. De nombreux centres exigent un frottis à jour avant de débuter un traitement.",
          "howItWorks": "Vous êtes allongée sur la table d'examen, les pieds dans des étriers. Un spéculum est inséré délicatement pour ouvrir le vagin et visualiser le col. Une petite brosse ou spatule sert à recueillir des cellules à la surface du col et au niveau de l'orifice cervical. Les cellules sont mises en milieu liquide et envoyées au laboratoire où elles sont examinées au microscope. Une recherche d'HPV peut être réalisée sur le même prélèvement.",
          "duration": "5 à 10 minutes",
          "whatToExpect": [
            "Léger inconfort ou pression à l'introduction du spéculum et lors du prélèvement",
            "Le prélèvement ne dure que quelques secondes",
            "Un léger spotting ensuite est possible et normal",
            "Résultats généralement disponibles sous 1 à 3 semaines",
            "Un résultat normal est habituellement valable 1 à 3 ans selon les recommandations"
          ],
          "results": [
            {
              "label": "Quand vous avez des nouvelles",
              "detail": "Les résultats de frottis reviennent généralement sous 1 à 3 semaines, selon le laboratoire et la recherche HPV éventuelle."
            },
            {
              "label": "Ce que vous apprenez",
              "detail": "Le compte rendu recherche des cellules cervicales anormales et peut inclure le statut HPV si le co-test a été demandé."
            },
            {
              "label": "Suivi",
              "detail": "Un résultat normal est souvent valable 1 à 3 ans, tandis qu'un résultat anormal peut nécessiter un contrôle ou une colposcopie."
            }
          ],
          "prepInstructions": [
            "Programmez l'examen en dehors des règles",
            "Évitez rapports vaginaux, douches vaginales et traitements vaginaux dans les 48 heures précédentes",
            "Signalez à votre centre une grossesse en cours ou supposée"
          ],
          "risks": [
            "Inconfort très léger pendant l'examen",
            "Léger spotting pendant un à deux jours est normal",
            "Aucun risque grave"
          ]
        }
      },
      "sources": [
        {
          "title": "Updated Cervical Cancer Screening Guidelines (Practice Advisory)",
          "authors": "American College of Obstetricians and Gynecologists",
          "journal": "ACOG",
          "year": 2021,
          "url": "https://www.acog.org/clinical/clinical-guidance/practice-advisory/articles/2021/04/updated-cervical-cancer-screening-guidelines",
          "evidenceLevel": "guideline"
        }
      ]
    }
  ],
  "relationships": [],
  "localeVariants": []
}
